import React,{useEffect, useState} from "react";
import "../../cssfiles/homepage.css";
import CustomTooltip from "./CustomTooltip";
import { Box, Typography } from "@mui/material";
import Button from '@mui/material/Button';

export default function CustomSelectedOptions({selectedOptions,onClick,disabled,chipWidth, id}) {
    const[assetData,setAssetData] = useState(selectedOptions);
    const [selectedValue, setselectedValue] = useState(0);
    
    // useEffect(()=>{
    //     //setAssetData(data);
    //     setselectedValue(0);
    // },[data])

    // useEffect(()=>{
    //     //assetData.splice(selectedValue,1)
    //     selected(assetData)
    // },[assetData])

    // useEffect(()=>{
    //      assetData.splice(selectedValue,1)
    //       setAssetData(assetData);
    //     // selected(assetData)
    // },[selectedValue])

    const handleClick = (event) => {
          //setselectedValue(event.target.id);
    //      //setAssetData(data);
          //assetData.splice(event.target.id,1);
          setselectedValue(event.target.id);
          onClick(event.target.id,id);
    };




    // function set(){
    //     setAssetData(data);
    // }
    

    return (
        <Box sx={{display:'flex',margin:'0px 0px 0px 0px',gap:'8px',flexWrap:'wrap',width:'100%',boxSizing:'border-box'}} >
            {selectedOptions.map((val,index) => (
                <Box  sx={{display:'flex', flexDirection:'row', height:'24px',width:chipWidth?chipWidth:'136px',background:'var(--Searchtext_muted)',padding:'4px',textAlign:'left',boxSizing:'border-box',gap:'4px'}} key={index}>
                    <CustomTooltip title={val} inputTitle={val} ifOverflow={true} offset={[30,-20]} placement={'right-end'}>
                        <Typography sx={{fontFamily:'Roboto',fontSize:'16px',lineHeight:1,fontWeight:'700',color:'var(--PrimaryText)',marginTop:'0px',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden',alignSelf:'end'}}>{val}</Typography>
                    </CustomTooltip>
                    <Box style={{flexGrow: 1}}></Box>
                    <Button id={index} onClick={handleClick} style={{height:"auto",lineHeight:1,maxWidth:"16px",minWidth:'6px',fontSize:'18px',fontWeight:'700',color:'var(--PrimaryText)',textTransform:'none',padding:0,margin:0,alignSelf:'end'}}>x</Button>
                </Box>
            ))}
        </Box>
    )
}